<ng-container *ngIf="user">
  <app-data-table-layout
    [actionsConfig]="{
      showSearch: true,
      showCreate: authService.hasRole('Editor'),
      showEdit: false,
      showDelete: authService.hasRole('Editor'),
      showDownload:false
      }"
    [currentValidationErrors]="currentValidationErrors"
    [columns]="columns"
    [resultSet]="resultSet"
    [editForms]="editForms"
    [editItemID]="editItemID"

    [currentPage]="currentPage"
    [totalPages]="totalPages"

    [generateLink]="generateLinkFn"
    [getDisplayValue]="getDisplayValueFn"

    (editStart)="onEditStart($event)"
    (deleteStart)="onDeleteStart($event)"
    (editSave)="onEditSave()"
    (editCancel)="onEditCancel()"
    (createStart)="onCreateStart()"
    (CSVDownload)="onDownloadCSV()"
    (search)="onSearch($event)"

    (currentPageChange)="onPageChange($event)"
    (goToFirstPage)="onFirstPage()"
    (goToPrevPage)="onPrevPage()"
    (goToNextPage)="onNextPage()"
    (goToLastPage)="onLastPage()"
  >
  <ng-template #rowActions let-item>
    <button class="btn btn-xs btn-info"  title="Download" (click)="downloadPdf(item)">
      <i class="fa fa-download"></i>
    </button>
    <button
      *ngIf="authService.hasRole('Editor')"
      class="btn btn-xs btn-info"
      title="Email invoice"
      [disabled]="sendingIds.has(item.id)"
      (click)="emailInvoice(item)"
    >
      <i class="fa" [ngClass]="sendingIds.has(item.id) ? 'fa-spinner fa-spin' : 'fa-envelope'"></i>
    </button>
  </ng-template>
  </app-data-table-layout>
</ng-container>
<app-details-view
  [(showModal)]="showModal"
  [columns]="columnsForCreate"
  title="Create {{ modelName }}"
  (save)="onCreate($event)"
></app-details-view>
<app-confirm-dialog
  *ngIf="showConfirmDialog"
  [title]="'Confirm Action'"
  [message]="confirmMessage"
  (confirm)="handleConfirm()"
  (cancel)="handleCancel()"
></app-confirm-dialog>
<app-confirm-dialog
  *ngIf="resendInvoice"
  [title]="'Resend Invoice'"
  [message]="resendMessage"
  (confirm)="confirmResend()"
  (cancel)="cancelResend()"
></app-confirm-dialog>
